import React from "react";

const educationContent = [
  {
    year: "2021",
    degree: "MASTER DEGREE",
    institute: "Bournemouth University, United Kingdom",
    details: `MSc Data Science & Artificial Intelligence`,
  },
  {
    year: "2012",
    degree: "ASSOCIATE OF CHARTERED ACCOUNTANT",
    institute: "Institute of Chartered Accountant of Nigeria",
    details: `ACA`,
  },
  {
    year: "2007",
    degree: "BACHELOR DEGREE ",
    institute: "Sikkim Manipal University, India",
    details: `BSc Applied Information Technology`,
  },
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
